/**
 * @description
 * Checks if `value` is `null`.
 *
 * @example
 * ``` ts
 * isNull(null);
 * // => true
 * isNull(undefined);
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is null, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-null
 */
export const isNull = (value): boolean => {
  return value === null;
};
